import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import { HomeStoreProvider } from 'context/HomeStore'
import { ErrorBoundary } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'

const HomePrivateRoute = ({ component: Component, componentProps = {}, ...rest }) => {
  const { authStore } = useAuthStore()
  return (
    <Route
      {...rest}
      render={props =>
        authStore.isLoggedIn ? (
          <ErrorBoundary>
            <HomeStoreProvider>
              <Component {...props} {...componentProps} />
            </HomeStoreProvider>
          </ErrorBoundary>
        ) : (
          <Redirect to={SIGN_IN_PATH} />
        )
      }
    />
  )
}

export default HomePrivateRoute
